const DATE_INPUT_FORMAT = 'MMM DD, YYYY';
const DATE_INPUT_FORMAT_WITH_NO_COMMA = 'MMM DD YYYY';
const DATE_INPUT_FORMAT_WITH_NO_YEAR = 'MMM DD';

const DATE_INPUT_FORMAT_WITH_SINGLE_DAY = 'MMM D, YYYY';
const DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_NO_COMMA = 'MMM D YYYY';
const DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_NO_YEAR = 'MMM D';

const DATE_INPUT_FORMAT_WITH_FULL_MONTH = 'MMMM DD, YYYY';
const DATE_INPUT_FORMAT_WITH_FULL_MONTH_AND_NO_COMMA = 'MMMM DD YYYY';
const DATE_INPUT_FORMAT_WITH_FULL_MONTH_AND_NO_YEAR = 'MMMM DD';

const DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_FULL_MONTH = 'MMMM D, YYYY';
const DATE_INPUT_FORMAT_WITH_SINGLE_AND_FULL_MONTH_DAY_AND_NO_COMMA = 'MMMM D YYYY';
const DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_FULL_MONTH_AND_NO_YEAR = 'MMMM D';

const DATE_INPUT_FORMAT_WITH_SLASH = 'MM/DD/YYYY';
const DATE_INPUT_FORMAT_WITH_SLASH_NO_YEAR = 'MM/DD';
const DATE_INPUT_FORMAT_WITH_DASH = 'MM-DD-YYYY';
const DATE_INPUT_FORMAT_WITH_DASH_NO_YEAR = 'MM-DD';
const DATE_INPUT_FORMAT_WITH_DOT = 'MM.DD.YYYY';
const DATE_INPUT_FORMAT_WITH_DOT_NO_YEAR = 'MM.DD';

export const VALID_DATE_INPUT_FORMATS = [
  DATE_INPUT_FORMAT_WITH_SLASH,
  DATE_INPUT_FORMAT_WITH_DASH,
  DATE_INPUT_FORMAT_WITH_DOT,
  DATE_INPUT_FORMAT,
  DATE_INPUT_FORMAT_WITH_NO_COMMA,
  DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_NO_COMMA,
  DATE_INPUT_FORMAT_WITH_SINGLE_DAY,
  DATE_INPUT_FORMAT_WITH_FULL_MONTH,
  DATE_INPUT_FORMAT_WITH_FULL_MONTH_AND_NO_YEAR,
  DATE_INPUT_FORMAT_WITH_NO_YEAR,
  DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_NO_YEAR,
  DATE_INPUT_FORMAT_WITH_SLASH_NO_YEAR,
  DATE_INPUT_FORMAT_WITH_DASH_NO_YEAR,
  DATE_INPUT_FORMAT_WITH_DOT_NO_YEAR,
  DATE_INPUT_FORMAT_WITH_FULL_MONTH_AND_NO_COMMA,
  DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_FULL_MONTH,
  DATE_INPUT_FORMAT_WITH_SINGLE_AND_FULL_MONTH_DAY_AND_NO_COMMA,
  DATE_INPUT_FORMAT_WITH_SINGLE_DAY_AND_FULL_MONTH_AND_NO_YEAR,
];
